var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollToTopButton",staticClass:"scroll-to-the-top",on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":require("@/assets/back-to-the-top-arrow.svg"),"alt":"back to the top arrow"}})])}
var staticRenderFns = []

export { render, staticRenderFns }